import 'globals';

(function ($, window, document, pageLoadedQueue) {
    pageLoadedQueue.push(function () {
        var draggableElems = document.querySelectorAll('.js--draggable'),
            isColliding = function ($baseElement, $checkingElement) {
                var firstElementOffset = $baseElement.offset(),
                    firstElementHeight = $baseElement.outerHeight(true),
                    firstElementWidth = $baseElement.outerWidth(true),
                    firstElementDistanceFromTop = firstElementOffset.top + firstElementHeight,
                    firstElementDistanceFromLeft = firstElementOffset.left + firstElementWidth,
                    checkingElementOffset = $checkingElement.offset(),
                    checkingElementHeight = $checkingElement.outerHeight(true),
                    checkingElementWidth = $checkingElement.outerWidth(true),
                    checkingElementDistanceFromTop = checkingElementOffset.top + checkingElementHeight,
                    checkingElementDistanceFromLeft = checkingElementOffset.left + checkingElementWidth,
                    notColliding = (firstElementDistanceFromTop < checkingElementOffset.top || firstElementOffset.top > checkingElementDistanceFromTop || firstElementDistanceFromLeft < checkingElementOffset.left || firstElementOffset.left > checkingElementDistanceFromLeft)
                ;

                return !notColliding;
            };

        for (var i = 0; i < draggableElems.length; i++) {
            var draggie = new Draggabilly(draggableElems[i], {
                containment: '.puzzle'
            });
            draggie.on('dragEnd', function (event, pointer) {
                $('#' + $(event.target).data('update')).val(isColliding($('#' + $(event.target).data('dropzone')), $(event.target)))
            });
        }
    });
})(jQuery, window, document, window.pageLoadedQueue);
